import React from "react";
import { connect } from "react-redux";
import {
  reduxForm,
  formValueSelector,
  change,
  submit,
  SubmissionError,
  stopSubmit,
} from "redux-form";
import Component from "./component";
import { previousStep, nextStep, setFormData } from "../pickup-form.actions";
import { addDonor, registerUser } from "api/users";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

// Validation
const validate = (values) => {
  const errors = {};

  // if(!values.phoneNumber){
  //     errors.password = 'Required'
  // }

  return errors;
};

let initialValues;

const mapStateToProps = (state, ownProps) => {
  initialValues = { ...initialValues, ...ownProps.initialValues };

  let props = {
    phoneNumber: state.donorWizard.formValues.phoneNumber,
  };

  return { initialValues, ...props };
};

const registerUserAction = (form) => {
  return (dispatch, getState) => {
    let state = getState();

    const { phoneNumber, fname, lname, email } = state.donorWizard.formValues;

    let registrationData = {
      phoneNumber: phoneNumber,
      password: form.password,
      fname: fname,
      lname: lname,
      email: email,
    };

    return registerUser(registrationData)
      .then((user) => {
        dispatch(setFormData({ user: user.data.data[0] }));
        Tracking.track("Step 5: Created New User with password");
        // TODO: Log this user in! Also, on error this should not continue
      })
      .catch((err) => {
        showToastError();
      });
  };
};

const continueAsGuestAction = (form) => {
  return (dispatch, getState) => {
    let state = getState();

    const { fname, lname, email, phoneNumber } = state.donorWizard.formValues;

    return addDonor({
      fname: fname,
      lname: lname,
      email: email,
      phoneNumbers: [{ number: phoneNumber }],
    })
      .then((user) => {
        Tracking.track("Step 5: Created New Guest Donor, no registration");

        dispatch(setFormData({ user: user.data.data[0] }));
        // This is interesting because we get a token back from a no password user. This would allow us to create a local user with no password.
        // authenticateDonorComplete(user)
        dispatch(nextStep());
      })
      .catch((err) => {
        showToastError();
      });
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (form) => dispatch(registerUserAction(form)),

    continueAsGuest: (form) => dispatch(continueAsGuestAction(form)),

    onSubmitSuccess: () => {
      dispatch(nextStep());
    },
    // previousStep: () => dispatch(previousStep())
  };
};

// Connect to the store using a container component
const withForm = reduxForm({ form: "publicPickupForm", validate })(Component);
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

export default withConnect;
